export default {
  state: {
    data: false,
  },
  getters: {
    //
  },
  actions: {
    resetABC(context) {
      context.commit("updateABC", false)
    },
  },
  mutations: {
    updateABC(state, data) {
      return state.data = data
    }
  }
}